// NoDataOverlay.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import SearchOffIcon from '@mui/icons-material/SearchOff';

export const NoDataOverlay = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100%"
    sx={{ backgroundColor: '#f5f5f5', color: '#888', p: 4 }}
  >
    <StorageIcon sx={{ fontSize: 60, mb: 1, color: '#90a4ae' }} />
    <Typography variant="h6" gutterBottom>
      No Data Available
    </Typography>
    <Typography variant="body2" textAlign="center">
      There's nothing here right now. Try adding a new entry.
    </Typography>
  </Box>
);

export const NoResultsOverlay = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100%"
    sx={{ backgroundColor: '#fff8f8', color: '#999', p: 4 }}
  >
    <SearchOffIcon sx={{ fontSize: 60, mb: 1, color: '#e57373' }} />
    <Typography variant="h6" gutterBottom>
      No Results Found
    </Typography>
    <Typography variant="body2" textAlign="center">
      We couldn't find any matching entries. Try changing your filters.
    </Typography>
  </Box>
);
